import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getallcategory, deletecategory } from "../../redux/Slices/extSlice";
import {
  Paper,
  TextField,
  Button,
  MenuItem,
  FormControl,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { toast } from "react-toastify";

const DeleteCategory = () => {
  const catref = useRef();
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);

  const { user } = useSelector((state) => state.user);
  const { allcategory } = useSelector((state) => state.ext);

  useEffect(() => {
    dispatch(getallcategory());
  }, [dispatch]);

  useEffect(() => {
    if (allcategory) {
      setCategories(allcategory.data);
    }
  }, [allcategory]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const categoryId = catref.current.value;

    if (!categoryId) {
      console.log("No category selected");
      return;
    }
    if (user?.role == "admin" || user?.user?.role == "admin") {
      dispatch(deletecategory({ id: categoryId }))
        .then((data) => {
          if (data.error) {
            throw new Error(data.error.message || "Error deleting category");
          }

          dispatch(getallcategory());
          catref.current.value = "";
        })
        .catch((err) => {
          console.log(err, "error message");
        });
    } else {
      toast.error("You are not authorize for this action", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  return (
    <Paper
      sx={{
        width: "75%",
        float: "right",
        overflow: "auto",
        marginTop: "8%",
        marginRight: "23px",
        padding: "20px",
      }}
    >
      <Typography variant="h6" fontWeight={600}>
      Select Category to Delete:
    </Typography>
    <br />
      {/* TOP FORM SECTION */}
      <form onSubmit={handleSubmit} style={{ width: "100%" }}>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "20px",
      width: "100%",
    }}
  >
    
    {/* SELECT DROPDOWN */}
    <FormControl fullWidth>
      <TextField
        select
        inputRef={catref}
        label="Select Category"
        defaultValue=""
        fullWidth
        variant="outlined"
        sx={{
          background: "#fff",
          borderRadius: "8px",
        }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {categories.map((category) => (
          <MenuItem value={category._id} key={category._id}>
            {category.cat_name}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>

    {/* DELETE BUTTON */}
    <Button
      type="submit"
      variant="contained"
      fullWidth
      sx={{
        width: "250px",
        padding: "12px",
        background: "linear-gradient(90deg, #6A4FE0, #594DFE)",
        "&:hover": {
          background: "linear-gradient(90deg, #5a43d5, #4a3ed8)",
        },
        borderRadius: "8px",
        fontWeight: "bold",
        textTransform: "none",
      }}
    >
      Delete Category
    </Button>
  </div>
</form>


      {/* DIVIDER */}
      <Divider sx={{ my: 4 }} />

      {/* CATEGORY LIST SECTION */}
      <Box sx={{ mt: 3 }}>
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ mb: 2 }}
        >
          Category Name
        </Typography>

        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            p: 2,
            minHeight: "200px",
          }}
        >
          {categories.map((category, index) => (
            <Typography
              key={index}
              sx={{
                fontSize: "16px",
                mb: 1.5,
                color: "#333",
              }}
            >
              {category.cat_name}
            </Typography>
          ))}
        </Box>
      </Box>
    </Paper>
  );
};

export default DeleteCategory;
